/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateNotifications = /* GraphQL */ `
  subscription MySubscription($username: String!) {
    onCreateNotifications(username: $username) {
      username
      type
      content
      sender
    }
  }
`;
